import { render } from "./TaseerSood.vue?vue&type=template&id=3c2bdbc5&scoped=true"
import script from "./TaseerSood.vue?vue&type=script&lang=js"
export * from "./TaseerSood.vue?vue&type=script&lang=js"

import "./TaseerSood.vue?vue&type=style&index=0&id=3c2bdbc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2bdbc5"]])

export default __exports__